<div class="purchase-dialog">

  <!-- Loading -->
  <div *ngIf="!loaded || awaitingSeats" class="purchase-loading">
    <ng-lottie [options]="{path: 'assets/lotties/loading.json'}" containerClass="loading-box"></ng-lottie>
  </div>

  <!-- Not found -->
  <div *ngIf="loaded && notFound" class="purchase-not-found">
    <i class="fa-light fa-circle-exclamation fa-3x"></i>
    <h2>Abono no encontrado</h2>
    <p>El abono que buscas no existe o no está disponible.</p>
    <button class="primary-button solid" (click)="close()">Cerrar</button>
  </div>

  <ng-container *ngIf="loaded && !notFound && pass && !awaitingSeats">

    <!-- Header -->
    <div class="purchase-header">
      <div class="header-info">
        <span class="header-pass-name">{{ pass.name }}</span>
        <span class="header-badge" *ngIf="getDiscountBadge()">
          <i class="fa-light fa-tag"></i> {{ getDiscountBadge() }}
        </span>
      </div>
      <div class="header-right">
        <div class="header-progress" *ngIf="!isSingleSeat && !unavailableMessage">
          <span class="progress-text">{{ completedCount }}/{{ minEvents }}</span>
          <div class="progress-bar-track">
            <div class="progress-bar-fill" [style.width.%]="progressPercent"></div>
          </div>
        </div>
        <div class="header-progress" *ngIf="isSingleSeat">
          <span class="progress-text">{{ passSeats.length }}/{{ quantity }}</span>
          <div class="progress-bar-track">
            <div class="progress-bar-fill" [style.width.%]="(passSeats.length / quantity) * 100"></div>
          </div>
        </div>
        <button class="btn-dialog-close" (click)="close()">
          <i class="fa-light fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Flexible notice -->
    <div class="flexible-notice" *ngIf="isFlexible && !isSingleSeat && !unavailableMessage">
      <i class="fa-light fa-circle-info"></i>
      Selecciona al menos <strong>{{ minEvents }}</strong> de {{ passEvents.length }} eventos
    </div>

    <!-- Abono de butaca única: un solo mapa para todos los eventos -->
    <ng-container *ngIf="isSingleSeat">
      <div class="flexible-notice">
        <i class="fa-light fa-chair"></i>
        <span *ngIf="quantity === 1">Tu butaca será la misma en los <strong>{{ passEvents.length }}</strong> eventos del abono</span>
        <span *ngIf="quantity > 1">Tus <strong>{{ quantity }}</strong> butacas serán las mismas en los <strong>{{ passEvents.length }}</strong> eventos del abono</span>
      </div>

      <div class="purchase-body">

        <div class="panel-left">
          <p class="panel-label">Incluye</p>
          <div class="events-list">
            <div class="event-item event-static"
                 *ngFor="let event of passEvents"
                 [class.completed]="!!passQuote"
                 [class.event-unavailable]="isEventUnavailable(event)">
              <i class="fa-light event-check"
                 [class.fa-circle-check]="!!passQuote"
                 [class.fa-calendar]="!passQuote">
              </i>
              <div class="event-item-body">
                <span class="event-item-name">{{ event.title }}</span>
                <span class="event-item-meta" *ngIf="event._sessionDate && !isEventUnavailable(event)">
                  {{ event._sessionDate | date:'dd MMM · HH:mm':'UTC' }}
                </span>
                <span class="event-item-meta event-badge-finished" *ngIf="event.active === false">
                  <i class="fa-light fa-ban"></i> No disponible
                </span>
                <span class="event-item-meta event-badge-finished" *ngIf="event._isFinished && event.active !== false">
                  <i class="fa-light fa-calendar-times"></i> Evento finalizado
                </span>
                <span class="event-item-meta event-badge-tpv" *ngIf="event.only_tpv_sales && !event._isFinished && event.active !== false">
                  <i class="fa-light fa-store"></i> Solo taquilla
                </span>
              </div>
            </div>
          </div>

          <div class="pass-total" *ngIf="passQuote">
            <span>Total</span>
            <strong>{{ passQuote.total | number:'1.2-2' }} €</strong>
          </div>

          <button class="btn-add-cart primary-button solid"
                  [disabled]="!passQuote || submitting"
                  (click)="addSingleSeatPassToCart()">
            <i class="fa-light fa-shopping-cart"></i>
            <span *ngIf="!submitting">Añadir al carrito</span>
            <span *ngIf="submitting">Añadiendo...</span>
          </button>
        </div>

        <div class="panel-center">

          <div *ngIf="loadingQuote" class="center-loading">
            <div class="spinner-ring"></div>
          </div>

          <div *ngIf="!loadingQuote" class="center-content">

            <div class="center-section" *ngIf="singleSeatBlocked">
              <div class="no-sessions">
                <i class="fa-light fa-calendar-times"></i>
                <span>Este abono ya no se puede comprar: alguno de sus eventos no está disponible.</span>
              </div>
            </div>

            <div class="center-section" *ngIf="!singleSeatBlocked && !passQuote">
              <p class="center-section-label">
                <i class="fa-light fa-chair"></i>
                Asiento{{ quantity > 1 ? 's' : '' }}
                <span class="qty-badge" *ngIf="quantity > 1">× {{ quantity }}</span>
              </p>
              <div class="seat-map-placeholder">
                <i class="fa-light fa-couch fa-2x"></i>
                <div class="seat-map-cta">
                  <p class="seat-map-hint">
                    En el mapa solo verás libres las butacas que lo están en todos los eventos
                  </p>
                  <button class="primary-button solid btn-open-map"
                          [disabled]="openingSeatPanel"
                          (click)="openPassSeatMap()">
                    <i class="fa-light fa-map"></i>
                    {{ openingSeatPanel ? 'Cargando...' : 'Abrir mapa de asientos' }}
                  </button>
                  <button class="btn-change-seat" *ngIf="!singleSeatRequired" (click)="backToEventByEvent()">
                    <i class="fa-light fa-list"></i> Elegir evento a evento
                  </button>
                </div>
              </div>
            </div>

            <div class="center-section" *ngIf="passQuote">
              <div class="pass-seats-header">
                <p class="center-section-label">
                  <i class="fa-light fa-chair"></i>
                  Tu{{ quantity > 1 ? 's' : '' }} butaca{{ quantity > 1 ? 's' : '' }}
                </p>
                <div class="pass-seats-actions">
                  <button class="btn-change-seat" *ngIf="!singleSeatRequired" (click)="backToEventByEvent()" [disabled]="submitting">
                    <i class="fa-light fa-list"></i> Elegir evento a evento
                  </button>
                  <button class="btn-change-seat" (click)="openPassSeatMap()" [disabled]="openingSeatPanel">
                    <i class="fa-light fa-pencil"></i> Cambiar butaca{{ quantity > 1 ? 's' : '' }}
                  </button>
                </div>
              </div>
              <div class="pass-seat-quote" *ngFor="let seat of passQuote.seats; let i = index">
                <div class="pass-seat-head">
                  <div class="seat-card-num">{{ i + 1 }}</div>
                  <div class="pass-seat-name">
                    <span class="pass-seat-level" *ngIf="seat.level">{{ seat.level }}</span>
                    <span class="pass-seat-label">Fila {{ seat.row }} · Butaca {{ seat.seat }}</span>
                  </div>
                  <strong class="pass-seat-total">{{ seat.total | number:'1.2-2' }} €</strong>
                </div>
                <div class="pass-seat-line" *ngFor="let line of seat.lines">
                  <span class="pass-line-event">{{ line.title }}</span>
                  <span class="pass-line-price">
                    <s *ngIf="line.discount > 0">{{ line.price | number:'1.2-2' }} €</s>
                    {{ line.total | number:'1.2-2' }} €
                  </span>
                </div>
              </div>
              <p class="pass-quote-hint">
                <i class="fa-light fa-circle-info"></i>
                <ng-container *ngIf="!isFixedPrices">Precios de la entrada general con el descuento del abono.</ng-container>
                <ng-container *ngIf="isFixedPrices">Precio del abono en cada evento según la zona de tu butaca.</ng-container>
                Los gastos de gestión, si los hay, se añaden en el carrito.
              </p>
            </div>

          </div>
        </div>

      </div>
    </ng-container>

    <!-- 2-panel body -->
    <div class="purchase-body" *ngIf="!isSingleSeat">

      <!-- LEFT: events list -->
      <div class="panel-left">
        <p class="panel-label">Eventos del abono</p>
        <div class="events-list">
          <div class="event-item"
               *ngFor="let event of passEvents"
               [class.active]="isCurrentEvent(event.id) && !isEventUnavailable(event)"
               [class.completed]="isEventCompleted(event.id)"
               [class.event-unavailable]="isEventUnavailable(event)"
               (click)="selectEvent(event)">
            <i class="fa-light event-check"
               [class.fa-circle-check]="isEventCompleted(event.id)"
               [class.fa-circle]="!isEventCompleted(event.id)">
            </i>
            <div class="event-item-body">
              <span class="event-item-name">{{ event.title }}</span>
              <span class="event-item-meta" *ngIf="isEventCompleted(event.id)">
                <i class="fa-light fa-calendar"></i>
                {{ getSelectionForEvent(event.id)?.sessionDate | date:'dd MMM · HH:mm':'UTC' }}
                <ng-container *ngIf="isFixedPrices"> · {{ getSelectionTotal(getSelectionForEvent(event.id)) | number:'1.2-2' }} €</ng-container>
              </span>
              <span class="event-item-meta map-tag" *ngIf="!isEventCompleted(event.id) && !isEventUnavailable(event) && (event.use_map || event.id_map)">
                <i class="fa-light fa-chair"></i> Numerado
              </span>
              <span class="event-item-meta event-badge-finished" *ngIf="event.active === false">
                <i class="fa-light fa-ban"></i> No disponible
              </span>
              <span class="event-item-meta event-badge-finished" *ngIf="event._isFinished && event.active !== false">
                <i class="fa-light fa-calendar-times"></i> Evento finalizado
              </span>
              <span class="event-item-meta event-badge-tpv" *ngIf="event.only_tpv_sales && !event._isFinished && event.active !== false">
                <i class="fa-light fa-store"></i> Solo taquilla
              </span>
            </div>
          </div>
        </div>

        <!-- Precio fijo: cada evento cobra el precio de su nivel, así que el total se ve al momento -->
        <div class="pass-total" *ngIf="isFixedPrices && completedCount > 0">
          <span>Total</span>
          <strong>{{ selectionsTotal | number:'1.2-2' }} €</strong>
        </div>

        <div class="requirements-box" *ngIf="!unavailableMessage" [class.done]="allEventsCompleted">
          <i class="fa-light" [class.fa-circle-check]="allEventsCompleted" [class.fa-clock]="!allEventsCompleted"></i>
          <span *ngIf="!allEventsCompleted">Faltan {{ minEvents - completedCount }} evento{{ (minEvents - completedCount) !== 1 ? 's' : '' }}</span>
          <span *ngIf="allEventsCompleted">¡Listo para añadir!</span>
        </div>

        <!-- Add to cart in left panel -->
        <button class="btn-add-cart primary-button solid" *ngIf="!unavailableMessage"
                [disabled]="!allEventsCompleted || submitting"
                (click)="addToCart()">
          <i class="fa-light fa-shopping-cart"></i>
          <span *ngIf="!submitting">Añadir al carrito</span>
          <span *ngIf="submitting">Añadiendo...</span>
        </button>
      </div>

      <!-- CENTER: event selector -->
      <div class="panel-center">

        <div *ngIf="loadingCenter" class="center-loading">
          <div class="spinner-ring"></div>
        </div>

        <div *ngIf="unavailableMessage" class="center-empty pass-unavailable">
          <i class="fa-light fa-calendar-times fa-2x"></i>
          <p>{{ unavailableMessage }}</p>
        </div>

        <div *ngIf="!loadingCenter && !centerEvent && !unavailableMessage" class="center-empty">
          <i class="fa-light fa-hand-pointer fa-2x"></i>
          <p>Selecciona un evento de la lista</p>
        </div>

        <div *ngIf="!loadingCenter && centerEvent" class="center-content">

          <!-- Event header -->
          <div class="center-event-header">
            <img *ngIf="centerEvent.image_url" [src]="urlImages + centerEvent.image_url"
                 fallimg class="center-event-img" alt="">
            <div class="center-event-info">
              <h3 class="center-event-title">{{ centerEvent.title }}</h3>
              <div class="center-event-tags">
                <span *ngIf="hasMap(centerEvent)" class="tag-map">
                  <i class="fa-light fa-chair"></i> Numerado
                </span>
                <span class="tag-sessions">
                  <i class="fa-light fa-calendar-alt"></i>
                  {{ futureSessions.length }} sesión{{ futureSessions.length !== 1 ? 'es' : '' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Session selector -->
          <div class="center-section">
            <p class="center-section-label">
              <i class="fa-light fa-calendar-check"></i> Sesión
            </p>
            <div *ngIf="futureSessions.length === 0" class="no-sessions">
              <i class="fa-light fa-calendar-times"></i>
              <span>Sin sesiones futuras disponibles</span>
            </div>
            <div class="sessions-grid">
              <div class="session-card"
                   *ngFor="let session of futureSessions"
                   [class.selected]="selectedSession?.id === session.id"
                   (click)="selectSession(session)">
                <i class="fa-light"
                   [class.fa-circle-check]="selectedSession?.id === session.id"
                   [class.fa-circle]="selectedSession?.id !== session.id">
                </i>
                <div class="session-card-info">
                  <span class="session-date">{{ session.start_date | date:'EEE, d MMM yyyy':'UTC' | titlecase }}</span>
                  <span class="session-time" *ngIf="(session.start_date | date:'HH:mm':'UTC') !== '00:00'">
                    {{ session.start_date | date:'HH:mm':'UTC' }}h
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tickets (no map) -->
          <ng-container *ngIf="selectedSession && !hasMap(centerEvent)">
            <div class="center-section">
              <p class="center-section-label">
                <i class="fa-light fa-ticket"></i> Entrada
                <span class="qty-badge" *ngIf="quantity > 1">× {{ quantity }}</span>
              </p>
              <div *ngIf="getAvailableTickets().length === 0" class="no-sessions">
                <span>Sin entradas disponibles</span>
              </div>
              <div class="tickets-list">
                <div class="ticket-option"
                     *ngFor="let ticket of getAvailableTickets()"
                     [class.selected]="selectedTicket?.id === ticket.id"
                     (click)="selectTicket(ticket)">
                  <i class="fa-light"
                     [class.fa-circle-check]="selectedTicket?.id === ticket.id"
                     [class.fa-circle]="selectedTicket?.id !== ticket.id">
                  </i>
                  <div class="ticket-option-info">
                    <span class="ticket-name">{{ ticket.name }}</span>
                    <span class="ticket-qty-hint" *ngIf="quantity > 1">{{ quantity }} entradas</span>
                  </div>
                  <span class="ticket-price">
                    {{ ticket.price | number:'1.2-2' }}€<span *ngIf="quantity > 1"> × {{ quantity }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="center-confirm">
              <button class="primary-button solid btn-confirm-event"
                      [disabled]="!selectedTicket"
                      (click)="confirmTicketSelection()">
                <i class="fa-light fa-check"></i>
                {{ isEventCompleted(centerEvent.id) ? 'Actualizar' : 'Confirmar' }}
                {{ quantity > 1 ? quantity + ' entradas' : 'selección' }}
              </button>
            </div>
          </ng-container>

          <!-- Seat map (with map) -->
          <ng-container *ngIf="selectedSession && hasMap(centerEvent)">
            <div class="center-section">
              <p class="center-section-label">
                <i class="fa-light fa-chair"></i>
                Asiento{{ quantity > 1 ? 's' : '' }}
                <span class="qty-badge" *ngIf="quantity > 1">× {{ quantity }}</span>
              </p>
              <div class="seat-map-placeholder">
                <i class="fa-light fa-couch fa-2x"></i>
                <div *ngIf="!isEventCompleted(centerEvent.id)" class="seat-map-cta">
                  <p class="seat-map-hint">
                    Elige {{ quantity > 1 ? quantity + ' asientos' : 'tu asiento' }} en el mapa del recinto<ng-container *ngIf="isFixedPrices">: el precio del abono depende de la zona</ng-container>
                  </p>
                  <button class="primary-button solid btn-open-map"
                          [disabled]="openingSeatPanel"
                          (click)="openSeatSelector()">
                    <i class="fa-light fa-map"></i>
                    {{ openingSeatPanel ? 'Cargando...' : 'Abrir mapa de asientos' }}
                  </button>
                </div>
                <div *ngIf="isEventCompleted(centerEvent.id)" class="seat-selected-info">
                  <div class="seat-cards-list">
                    <div class="seat-card-green" *ngFor="let seat of getSelectionForEvent(centerEvent.id)?.seats; let i = index">
                      <div class="seat-card-left">
                        <div class="seat-card-num">{{ i + 1 }}</div>
                        <i class="fa-light fa-circle-check seat-card-icon"></i>
                      </div>
                      <div class="seat-card-body">
                        <span class="seat-card-section" *ngIf="seat.section">{{ seat.section }}</span>
                        <span class="seat-card-label">Fila {{ seat.row }} · Butaca {{ seat.seat }}</span>
                      </div>
                    </div>
                  </div>
                  <p class="seat-map-hint" *ngIf="isFixedPrices">
                    Precio del abono en este evento: <strong>{{ getSelectionTotal(getSelectionForEvent(centerEvent.id)) | number:'1.2-2' }} €</strong>
                  </p>
                  <button class="btn-change-seat" (click)="openSeatSelector()" [disabled]="openingSeatPanel">
                    <i class="fa-light fa-pencil"></i> Cambiar asientos
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>

    </div>
  </ng-container>
</div>
